import { render, staticRenderFns } from "./TkRoomTypeCard.vue?vue&type=template&id=c76c807a&"
import script from "./TkRoomTypeCard.vue?vue&type=script&lang=js&"
export * from "./TkRoomTypeCard.vue?vue&type=script&lang=js&"
import style0 from "./TkRoomTypeCard.vue?vue&type=style&index=0&id=c76c807a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports